"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSet = void 0;

var React = __importStar(require("react"));

function useSet(initialSet) {
  if (initialSet === void 0) {
    initialSet = new Set();
  }

  var _a = React.useState(initialSet),
      state = _a[0],
      setState = _a[1];

  var stableMethods = React.useMemo(function () {
    return {
      add: function add(item) {
        setState(function (prevState) {
          return new Set(__spreadArrays(Array.from(prevState), [item]));
        });
      },
      remove: function remove(item) {
        setState(function (prevState) {
          return new Set(Array.from(prevState).filter(function (i) {
            return i !== item;
          }));
        });
      },
      toggle: function toggle(item) {
        setState(function (prevState) {
          return prevState.has(item) ? new Set(__spreadArrays(Array.from(prevState), [item])) : new Set(Array.from(prevState).filter(function (i) {
            return i !== item;
          }));
        });
      },
      reset: function reset() {
        setState(initialSet);
      }
    };
  }, [setState]);
  var unstableMethods = {
    has: React.useCallback(function (item) {
      return state.has(item);
    }, [state])
  };

  var methods = __assign(__assign({}, stableMethods), unstableMethods);

  return [state, methods];
}

exports.useSet = useSet;